import React from 'react';
import { Button } from '@/components/ui/button';
import relativeTime from 'dayjs/plugin/relativeTime';
import dayjs from 'dayjs';
import { createPortal } from 'react-dom';
import { ChevronLeft } from 'lucide-react';
dayjs.extend(relativeTime);

// 格式化相对时间
const formatRelativeTime = time => {
  const now = dayjs();
  const targetTime = dayjs(time);
  const diffInSeconds = now.diff(targetTime, 'second');

  if (diffInSeconds < 60) {
    return `${diffInSeconds}秒前`;
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes}分钟前`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours}小时前`;
  } else if (diffInSeconds < 2592000) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days}天前`;
  } else if (diffInSeconds < 31536000) {
    const months = Math.floor(diffInSeconds / 2592000);
    return `${months}月前`;
  } else {
    const years = Math.floor(diffInSeconds / 31536000);
    return `${years}年前`;
  }
};

interface MoreNewsDialogProps {
  newsData: any[];
  setOpen: (open: boolean) => void;
}

const MoreNewsDialog: React.FC<MoreNewsDialogProps> = ({ newsData, setOpen }) => {
  const handleToLink = (link: string) => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return createPortal(
    <div className="fixed inset-0 bottom-0 top-0 z-[1111111] min-h-screen overflow-y-scroll bg-white pb-4">
      <div className="flex h-full flex-col bg-white px-3">
        <div className="relative my-6 w-full">
          <div
            className="absolute left-0 top-0 flex h-7 cursor-pointer items-center"
            onClick={() => setOpen(false)}
          >
            <ChevronLeft size={16} />
          </div>
          <div className="text-center text-xl font-semibold text-gray-900">今日热门资讯</div>
        </div>

        <div className="space-y-2">
          {newsData.map(item => (
            <div key={item.title} className="flex flex-col gap-2 rounded-md bg-purple-50 px-3 py-2">
              <div>
                <div className="flex items-center gap-2">
                  <div className="min-w-0 flex-1 text-sm">
                    <div>
                      <Button
                        variant="link"
                        onClick={() => handleToLink(item.link)}
                        className="h-auto w-full p-0"
                      >
                        <div
                          className="w-full truncate text-left"
                          style={{ color: 'rgba(89, 89, 235, 1)' }}
                        >
                          {item.title}
                        </div>
                      </Button>
                    </div>
                  </div>

                  <div className="whitespace-nowrap text-xs text-gray-500">
                    {formatRelativeTime(item.public_time)}
                  </div>
                </div>
              </div>

              <div className="text-[rgb(31, 31, 31)] text-left text-sm">{item.content}</div>

              <div className="text-left text-xs text-[rgb(140,140,140)]">
                <span>来源：</span>
                <span>{item.source}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.querySelector('#root')
  );
};

export default MoreNewsDialog;
